const data = {
  title: 'What would they choose?',
  description:
    'Skipping the formal funeral service frees you up to remember your loved one in a more fitting way. You could…',

  steps: [
    {
      image: 'illustrations/hire-the-town-hall',
      content: 'Enjoy their favourite view or walk',
    },
    {
      image: 'illustrations/make-it-a-party',
      content:
        'Raise a glass of their favourite drink or share the meal they loved',
    },
    {
      image: 'illustrations/have-a-family-feast',
      content: 'Get everyone together for a send-off',
    },
    {
      image: 'illustrations/coins-turtle-revised',
      content: 'Fundraise for a charity close to their heart',
    },
  ],
}

export default data
